<template>
  <b-autocomplete
    ref="autocomplete"
    v-model="inputValue"
    placeholder="Select a church"
    :open-on-focus="true"
    :data="filteredRecords"
    :custom-formatter="customFormatter"
    :loading="fetchingChurches"
    @select="onSelect"
  >
    <template slot-scope="props">
      {{ props.option.name_zh }}
      <br />
      {{ props.option.name_en }}
    </template>
  </b-autocomplete>
</template>

<style scoped lang="less"></style>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "ChurchSelect",
  props: ["value"],
  data() {
    return {
      records: [],
      isLoading: true,
      inputValue: this.value,
    };
  },
  computed: {
    ...mapState(["churches", "fetchingChurches"]),
    filteredRecords: function () {
      if (
        this.inputValue === undefined ||
        this.inputValue === null ||
        typeof this.value === "number"
      ) {
        return this.churches;
      } else {
        return this.churches.filter((record) => {
          return (
            record.name_zh.toString().indexOf(this.inputValue.toString()) >=
              0 ||
            record.name_en
              .toString()
              .toLowerCase()
              .indexOf(this.inputValue.toString().toLowerCase()) >= 0
          );
        });
      }
    },
  },
  watch: {
    value: function () {
      this.selectById();
    },
    churches: function () {
      this.selectById();
    },
  },
  mounted() {
    this.getChurches();
  },
  methods: {
    ...mapActions(["getChurches"]),
    selectById() {
      this.$emit("selectByIdStart");
      for (var i = 0; i < this.churches.length; i++) {
        if (this.churches[i].id === this.value) {
          this.$refs.autocomplete.setSelected(this.churches[i]);
          break;
        }
      }
      this.$emit("selectByIdEnd");
    },
    customFormatter(record) {
      return [record.name_zh, record.name_en].join(" ");
    },
    onSelect(option) {
      if (option === null) {
        this.$emit("input", undefined);
      } else {
        this.$emit("input", option.id);
      }
    },
  },
};
</script>
